import { render, staticRenderFns } from "./vehicleinspactions.html?vue&type=template&id=2c229f6c&scoped=true&external"
import script from "./vehicleinspactions.vue?vue&type=script&lang=js"
export * from "./vehicleinspactions.vue?vue&type=script&lang=js"
import style0 from "./vehicleinspactions.vue?vue&type=style&index=0&id=2c229f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c229f6c",
  null
  
)

export default component.exports